// todo: consolidate this module with the one in react-sso-landing
import React, {Component} from 'react';
import {TextField, withStyles} from "@material-ui/core";
import ErrorFormatter from "../ErrorFormatter";
import messages from "../../messages";
import PropTypes from 'prop-types';

const styles = theme => ({
  textField: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  errorListText: {
    color: "crimson",
    minWidth: "100%",
    textAlign: "left",
    paddingTop: "0px !important",
    paddingBottom: "0px !important",
    margin: "0px",
    fontSize: '13px'
  },
  validationErrorsList: {
    padding: "0px"
  },
})

export class PasswordField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validationErrors: [],
      password: ''
    };
  }

  handleUpdate = event => {
    let state = this.state;
    state.validationErrors = [];
    if (event.target.value) {
      state.password = event.target.value;
      state.validationErrors = this.props.passwordValidator.validatePassword(event.target.value);
    }
    this.setState(state);
    this.props.onChange({
      target: {
        name: this.props.name,
        password: state.password,
        valid: state.validationErrors.length === 0 && state.password.length > 0
      }
    });
  }

  render() {
    const {classes} = this.props;
    if (this.state.password.length > 0 && this.props.match && this.props.match !== this.state.password) {
      this.state.validationErrors.push({message: messages.changePasswordPasswordsDoNotMatch, context: {}})
    }
    return (
      <React.Fragment>
        <TextField
          id={this.props.id}
          error={this.state.validationErrors.length > 0}
          className={classes.textField}
          type="password"
          name={this.props.name}
          onChange={this.handleUpdate}
          label={this.props.label}
          fullWidth={true}
        />
        <ErrorFormatter validationErrors={this.state.validationErrors}/>
      </React.Fragment>
    )
  }
}

PasswordField.propTypes = {
  passwordValidator: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  match: PropTypes.string,
  label: PropTypes.oneOf([
    PropTypes.func,
    PropTypes.string,
    PropTypes.object
  ])
}
export default withStyles(styles)(PasswordField)